import { Grid, LinearProgress, Typography, Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import NumberFormat from "react-number-format";
import withProfileRedirect from "../../containers/App/withProfileRedirect";

import { useErrorHandler } from "react-error-boundary";
import InfiniteScroll from "react-infinite-scroll-component";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { setBlockRequest } from "../../globalRedux/actions";
import {
  checkAcctStsCashIn,
  checkAcctStsCashOut,
} from "../../utils/functions/validationsDeposit";
import { getRspDetail, setbackPayloadRsp } from "../deposit/redux/action";
import {
  getCustomer,
  getTransactionHistory,
  setCifPlanId,
  setGeneralSavingDetails,
  setSavingGoalDetails,
  setSavingType,
} from "../redux/action";
import {
  CATEGORY_SAVING,
  GENERAL_SAVING,
  GOALDETAILS,
} from "../redux/constant";
import { getSubAccount } from "./redux/actions";

import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Alert,
  AlertAccount,
  AlertDDA,
  DefaultLoader,
  MenuBar,
  SavingDetailCard,
  Transaction,
  TransactionInfiniteLoader,
} from "../../components";
import { images } from "../../constants";
import { NOT_ALLOWED_ACCOUNT_STATUS } from "../../constants/subaccount-status";
import { setCurrentEcddStatus } from "../../globalRedux/actions";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import { getRoundedValue } from "../../utils/functions/getRoundedValue";
import { transformMiniTransactions } from "../../utils/functions/transformMiniTransactions";
import { useEcddChecking } from "../../utils/hooks";
import { setLastAmountSave } from "../deposit/redux/action";
import { ddaStatus, setRspButton } from "../fundDetails/utils";
import { resetSelectedPromo } from "../promoList/redux/action";
import { styled } from "@mui/material/styles";

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  "&.MuiLinearProgress-colorPrimary": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  "& .MuiLinearProgress-barColorPrimary": {
    background: "linear-gradient(87deg, #bee4fb 37%, #e5f4fb 105%)",
  },
}));

const GoalDetails = props => {
  const {
    customerGoals,
    transactionHistory,
    ecddStatus,
    getTransactionHistory,
    setSavingGoalDetails,
    setGeneralSavingDetails,
    setSavingType,
    history,
    match,
    getCustomer,
    profile,
    setbackPayloadRsp,
    resetSelectedPromo,
    getSubAccount,
    subAccountLoading,
    subAccountDetail,
    commingFrom = "/",
    blockRequest,
    loadingTransactionHistory,
    isEcddCompleted,
    setCurrentEcddStatus,
    setLastAmountSave,
    getRspDetail,
    rspDetail,
    loadingRspDetail,
  } = props;

  const savingGoalId = match.params.id;

  const errorHandler = useErrorHandler();

  const [rspSetup, setRspSetup] = useState({ edit: false, setup: false });
  const [ddaPending, setDdaPending] = useState(false);
  const [accountSts, setAccountSts] = useState({
    status: "Active",
    alert: false,
    blockedRsp: false,
    blockedCashIn: false,
    blockedCashout: false,
  });
  const { handleCheckEcdd, status, onResetStatus } = useEcddChecking({
    ecddStatus,
    aml: profile &&
      profile.amlHistory.length > 0 &&
      typeof profile.amlHistory[0] === "object" && {
        result: profile.amlHistory[0].amlResult,
        status: profile.amlHistory[0].amlSts,
      },
    shouldNotPromptOnEffect: !isEcddCompleted,
  });
  const liveAgentWhatsappNumber =
    process.env.REACT_APP_LIVE_AGENT_WHATSAPP_NUMBER?.trim();

  const liveAgentWhatsappNumberException1 =
    process.env.REACT_APP_LIVE_AGENT_WHATSAPP_NUMBER_EXCEPTION_1?.trim();

  const [savingDetail] = useState(() => {
    const goal = customerGoals.find(item => item.id === savingGoalId);

    // in order for react error boundary to catch the error outside the render lifecycle
    // we'll intentionally throw error here in case goal is not found
    if (!goal) {
      errorHandler(`Cannot find the goal with the id of ${savingGoalId}`);
    }

    return goal;
  });

  const [transactions, setTransactions] = useState([]);

  const pageNumber = useRef(1);
  const transactionsLength = useRef(0);

  const { numPages, totalPages } = transactionHistory;

  const headAccountCheck = type => {
    const { headAccount } = profile;
    const accountStatus = headAccount?.sts;

    if (accountStatus) {
      const isSuspended = accountStatus === "Suspended";
      const isDeactivated = NOT_ALLOWED_ACCOUNT_STATUS.includes(accountStatus);

      if (isSuspended || isDeactivated) {
        if (isSuspended && (type === "cashOut" || type === "switch")) {
          return true;
        }
        if (
          headAccount.sts === "Closing" &&
          (type === "cashOut" || type === "switch")
        ) {
          return true;
        }
        if (
          type === "edit" &&
          !["0", "21", "26"].includes(rspDetail.rspStatus)
        ) {
          return true;
        }
        setAccountSts(prev => ({
          ...prev,
          alert: true,
          status: isSuspended ? "Suspended" : "Deactived",
        }));

        return false;
      }
    }

    return true;
  };

  /**
   *  Check saving type
   *  Navigate to deposit screen
   */

  const handleDeposit = () => {
    if (!headAccountCheck()) {
      return;
    }
    if (accountSts.blockedCashIn) {
      setAccountSts({ ...accountSts, alert: true });
      return;
    }

    if (savingDetail.plan.retailFlag === true) {
      setSavingType(GENERAL_SAVING);
    } else {
      setSavingType(CATEGORY_SAVING);
    }
    setSavingGoalDetails(savingDetail);
    history.push(`/make-deposit/${GOALDETAILS}`);
  };

  const handleWithdraw = () => {
    dataLayerGTM("click_tag", "Click", "Dropdown", "Cash Out");

    if (!headAccountCheck("cashOut")) {
      return;
    }

    if (accountSts.blockedCashout) {
      setAccountSts({ ...accountSts, alert: true });
      return;
    }

    if (savingDetail.plan.retailFlag === true) {
      setSavingType(GENERAL_SAVING);
      setGeneralSavingDetails(savingDetail);
    } else {
      setSavingType(CATEGORY_SAVING);
      setSavingGoalDetails(savingDetail);
    }

    history.push("/make-withdrawal");
  };

  const myReduce = data => {
    return data.reduce(
      (acc, curr) =>
        acc + parseFloat(curr.unitHeld) * parseFloat(curr.fund.nav),
      0
    );
  };

  const mySavingValue = data => {
    const asset = data.currentValue
      ? getRoundedValue(data.currentValue, 2)
      : Array.isArray(data.portfolio)
      ? getRoundedValue(myReduce(data.portfolio), 2)
      : getRoundedValue(
          parseFloat(data.portfolio.unitHeld) *
            parseFloat(data.portfolio.fund.nav),
          2
        );

    const assetPercent = data.targetPercentage
      ? Number(data.targetPercentage)
      : (asset / parseFloat(data.targetAmount)) * 100;
    const isAssetNotComplete = asset - parseFloat(data.targetAmount) < 0;

    return { asset, assetPercent, isAssetNotComplete };
  };

  const handleRSP = () => {
    dataLayerGTM("click_tag", "Click", "Button", "Goal detail - RSP");
    props.setBlockRequest(false);

    const ddaResult = ddaStatus(savingDetail.rspStatus);
    if (ddaResult) {
      setDdaPending(ddaResult);
      return;
    }

    if (accountSts.blockedRsp) {
      setAccountSts(prev => ({ ...prev, alert: true }));
      return;
    }

    if (savingDetail.plan.retailFlag === true) {
      setSavingType(GENERAL_SAVING);
      setGeneralSavingDetails(savingDetail);
    } else {
      setSavingType(CATEGORY_SAVING);
      setSavingGoalDetails(savingDetail);
    }
    let rspSet = "setupRSP";
    if (rspSetup.edit) {
      rspSet = "edit";
    }
    if (!headAccountCheck(rspSet)) {
      return;
    }
    history.push(`make-deposit/GOAL_DETAIL/success/auto-deposit/${rspSet}`);
  };

  useEffect(() => {
    if (!blockRequest) {
      getCustomer();
    }
    getTransactionHistory(
      {
        page: pageNumber.current,
        size: 10,
        cifPlanId: savingGoalId,
      },
      transactionsResponse => {
        if (!transactionsResponse) return;

        transactionsLength.current = transactionsResponse.length;

        setTransactions(prev => [
          ...transformMiniTransactions(transactionsResponse, prev),
        ]);
      }
    );
    setbackPayloadRsp({});
    setLastAmountSave();
    resetSelectedPromo();
    sessionStorage.removeItem("stopRsp");

    return () => {};
  }, []);

  /**
   *  Get goal detail by id & set RSP status
   */
  useEffect(() => {
    if (savingDetail && typeof savingDetail === "object") {
      getRspDetail(savingDetail.id);
      setRspSetup(setRspButton(savingDetail));

      if (
        savingDetail.accountNo &&
        typeof savingDetail.accountNo === "string"
      ) {
        getSubAccount(savingDetail.accountNo);
      }
    }
  }, [savingDetail]);

  const handleSwitching = () => {
    if (!headAccountCheck("switch")) {
      return;
    }
    history.push("/switching/create", {
      id: savingGoalId,
      productType: "save",
    });
  };

  /**
   * * GET subAccount status to decide can do transaction or no
   * * START
   */
  useEffect(() => {
    if (!subAccountDetail) {
      return;
    }
    let newObj = {
      status: "Active",
      alert: false,
      blockedRsp: false,
      blockedCashIn: false,
      blockedCashout: false,
    };
    if ("sts" in subAccountDetail) {
      let { sts } = subAccountDetail;
      newObj.status = sts;
      let stopCashOut = checkAcctStsCashOut(sts);
      let stopCashIn = checkAcctStsCashIn(sts);
      if (!stopCashIn) {
        newObj.blockedCashIn = true;
      }
      if (!stopCashOut) {
        newObj.blockedCashout = true;
      }

      if (
        (rspSetup.setup || ["0", "21", "26"].includes(rspDetail.rspStatus)) &&
        NOT_ALLOWED_ACCOUNT_STATUS.includes(sts)
      ) {
        newObj.blockedRsp = true;
      }
      setAccountSts(newObj);
    }
  }, [subAccountDetail, rspDetail, rspSetup]);
  /**
   ** check if subaccount status is posible to do transaction
   ** end
   */

  if (
    loadingRspDetail ||
    (loadingTransactionHistory && pageNumber.current === 1) ||
    subAccountLoading
  )
    return <DefaultLoader />;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: "100vh",
      }}
    >
      <AlertDDA
        title="This Goal or Fund has already enabled Auto Cash In."
        firstText="Your Auto Cash In request is being processed, please come back and check the status later."
        isOpen={ddaPending}
        handleClose={() => setDdaPending(false)}
      />
      <Alert
        title="Account Verification"
        description="Thank you for submitting your information. We need to perform further verification to activate your account."
        isOpen={status === "pending"}
        isCS="https://principal.com.my"
        isCancel={false}
        btnTxt="Chat with us on WhatsApp"
        handleAction={() => {
          setCurrentEcddStatus(false);
          onResetStatus();
          window.my.call("openAppLink", {
            url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
          });
        }}
        handleCancel={() => {
          setCurrentEcddStatus(false);
          onResetStatus();
        }}
      />
      <Alert
        title="Your account is deactivated"
        description="So sorry, your account is deactivated. We need to perform a verification to activate your account."
        isOpen={status === "rejected"}
        isCS="https://principal.com.my"
        isCancel={false}
        btnTxt="Chat with us on WhatsApp"
        handleAction={() => {
          onResetStatus();
          window.my.call("openAppLink", {
            url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
          });
        }}
        handleCancel={onResetStatus}
      />
      <AlertAccount
        title={`Account ${
          accountSts.status === "Suspended" ? "Suspended" : "Inactive"
        }`}
        firstText={
          accountSts.status === "Suspended"
            ? "Your account is currently suspended, we are unable to process your Cash In request however, you can still proceed with Cash Out."
            : "Your account is currently inactive, we're sorry for the inconvenience."
        }
        secondText={
          <p>
            For assistance, kindly contact our{" "}
            <span
              onClick={() => {
                setAccountSts({ ...accountSts, alert: false });

                window.my.call("openAppLink", {
                  url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
                });
              }}
              style={{ color: "#1278CC" }}
            >
              Customer Care Centre.
            </span>
          </p>
        }
        isOpen={accountSts.alert}
        handleClose={() => setAccountSts({ ...accountSts, alert: false })}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundImage: `url(${images.bgSavingDetails})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          paddingBottom: "24px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            margin: "16px 16px 8px",
          }}
        >
          <ArrowBackOutlinedIcon
            style={{ cursor: "pointer", color: "#ffffff", fontSize: 24 }}
            onClick={() => history.push(commingFrom)}
          />
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <InfoOutlinedIcon
              className="material-icons-outlined"
              fontSize="small"
              sx={{ cursor: "pointer", color: "#fff", fontSize: 18, position: "relative", top: "2px" }}
            />
            <Typography
              sx={{ marginLeft: "6px", color: "#fff" }}
              onClick={() => {
                window.my.navigateTo({
                  url:
                    "/pages/link/link?url=" +
                    encodeURIComponent(
                      process.env.REACT_APP_ENV.trim() === "production"
                        ? "https://www.principal.com.my/en/immfd/mv"
                        : "https://www.test.principal.com.my/en/immfd/mv"
                    ),
                });
              }}
            >
              Fund info
            </Typography>
          </Box>
        </Box>

        {/* Saving Name */}
        <Box sx={{ margin: "24px 16px 0" }}>
          <Box
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <img
              src={
                savingDetail.product.image
                  ? savingDetail.product.image
                  : images.generalSavings
              }
              alt={
                savingDetail.planAlias
                  ? savingDetail.planAlias
                  : "general-saving"
              }
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "4px",
                objectFit: "cover",
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "16px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "900",
                  fontSize: "20px",
                  lineHeight: 1.4,
                  color: "#fff",
                }}
              >
                {savingDetail.planAlias}
              </Typography>
            </Box>
          </Box>
          {savingDetail.planAlias !== "General Savings" &&
            savingDetail.planAlias !== "General Saving" && (
              <>
                <StyledLinearProgress
                  variant="determinate"
                  value={mySavingValue(savingDetail).assetPercent}
                  sx={{ marginTop: "16px", borderRadius: "4px", height: "8px" }}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "4px",
                  }}
                >
                  <Typography
                    sx={{ fontSize: "14px", lineHeight: 1.57 }}
                    style={{
                      color: mySavingValue(savingDetail).isAssetNotComplete
                        ? "#fff"
                        : "#ddf75b",
                      fontWeight: "900",
                    }}
                  >
                    {mySavingValue(savingDetail).isAssetNotComplete ? (
                      <>
                        {mySavingValue(savingDetail).asset < 0 && "-"}
                        RM{" "}
                        <NumberFormat
                          value={
                            mySavingValue(savingDetail).asset > 0
                              ? mySavingValue(savingDetail).asset
                              : mySavingValue(savingDetail).asset * -1
                          }
                          thousandSeparator
                          displayType="text"
                          decimalScale={2}
                          fixedDecimalScale
                        />
                      </>
                    ) : (
                      `Completed`
                    )}
                  </Typography>
                  <Typography
                    color="textPrimary"
                    sx={{
                      fontWeight: "900",
                      fontSize: "14px",
                      lineHeight: 1.57,
                    }}
                    style={{
                      color:
                        mySavingValue(savingDetail).assetPercent < 100
                          ? "#fff"
                          : "#ddf75b",
                    }}
                  >
                    {mySavingValue(savingDetail)
                      .assetPercent.toFixed(2)
                      .replace(/[.,]00$/, "")}
                    %
                  </Typography>
                </Box>
              </>
            )}
        </Box>

        {/* Saving Details */}
        <Box sx={{ margin: "16px" }}>
          <Grid container spacing={1}>
            <Grid item size={6}>
              <SavingDetailCard
                label="Projected Return Rate"
                detail={`${savingDetail.plan.expPerf.toFixed(2)}%`}
              />
            </Grid>
            <Grid item size={6}>
              <SavingDetailCard
                label="Total Return"
                detail={
                  savingDetail.totalGain
                    ? getRoundedValue(savingDetail.totalGain, 2)
                    : `${getRoundedValue(
                        mySavingValue(savingDetail).asset -
                          savingDetail.totalCashIn,
                        2
                      )}`
                }
                isMoney={true}
              />
            </Grid>
            {savingDetail.planAlias === "General Saving" ||
            savingDetail.planAlias === "General Savings" ? (
              <Grid item size={12}>
                <SavingDetailCard
                  label="Investment Cost"
                  detail={
                    savingDetail.totalCost
                      ? parseFloat(savingDetail.totalCost)
                      : parseFloat(savingDetail.totalCashIn)
                  }
                  isMoney={true}
                />
              </Grid>
            ) : (
              <>
                <Grid item size={6}>
                  <SavingDetailCard
                    label="Goal Target"
                    detail={savingDetail.targetAmount}
                    isMoney={true}
                  />
                </Grid>
                <Grid item size={6}>
                  <SavingDetailCard
                    label="Investment Cost"
                    detail={
                      savingDetail.totalCost
                        ? parseFloat(savingDetail.totalCost)
                        : parseFloat(savingDetail.totalCashIn)
                    }
                    isMoney={true}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </Box>
      {/* History transfer */}
      <Box
        sx={{
          backgroundColor: "#f6f6f8",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {transactions && transactions.length > 0 && (
          <Typography
            sx={{
              padding: "16px 16px 0",
              color: "#616367",
            }}
          >
            You can refer to your Cash In or Cash Out under processing at{" "}
            <span
              style={{ color: "#1278CC" }}
              onClick={() => history.push("/transaction")}
            >
              transaction history
            </span>
            .
          </Typography>
        )}
        {transactions && transactions.length > 0 ? (
          <InfiniteScroll
            dataLength={transactionsLength.current}
            style={{ paddingBottom: "8rem" }}
            next={() => {
              if (window.scrollY === 0) return;

              getTransactionHistory(
                {
                  page: (pageNumber.current += 1),
                  size: 10,
                  cifPlanId: savingGoalId,
                },
                transactionsResponse => {
                  if (!transactionsResponse) return;

                  transactionsLength.current += transactionsResponse.length;

                  setTransactions(prev => [
                    ...transformMiniTransactions(transactionsResponse, prev),
                  ]);
                }
              );
            }}
            hasMore={numPages < totalPages}
            loader={
              loadingTransactionHistory &&
              pageNumber.current > 1 && (
                <TransactionInfiniteLoader style={{ marginTop: "30px" }} />
              )
            }
          >
            <Transaction transactions={transactions} />
          </InfiniteScroll>
        ) : (
          <Box
            sx={{
              lineHeight: 1.38,
              color: "#616367",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "auto 0",
              fontFamily: "FSElliotPro",
              fontSize: "16px",
              fontWeight: "normal",
            }}
          >
            <div>
              You can refer to your Cash In or Cash Out under processing at{" "}
              <span
                style={{ color: "#1278CC" }}
                onClick={() => history.push("/transaction")}
              >
                transaction history
              </span>
              .
              <br />
              Start Cash In now.
            </div>
          </Box>
        )}
      </Box>
      <div
        style={{
          backgroundColor: "#ffffff",
          position: "fixed",
          bottom: 0,
          minHeight: "6rem",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0px -2px 12px rgba(0, 0, 0, 0.06)",
        }}
      >
        <MenuBar
          rspText={rspSetup.edit ? "Edit" : "Auto Cash In"}
          handleSwitching={handleCheckEcdd({
            cb: handleSwitching,
            ecddExpiredCb: () => history.push("/onBoarding/ecdd/GOALDETAILS"),
            gtm: {
              event: "click_tag",
              action: "Click",
              category: "Button",
              label: "Switching Goal Detail",
            },
          })}
          handleWithdraw={handleWithdraw}
          handleDeposit={handleCheckEcdd({
            cb: handleDeposit,
            ecddExpiredCb: () => history.push("/onBoarding/ecdd/GOALDETAILS"),
            gtm: {
              event: "click_tag",
              action: "Click",
              category: "Button",
              label: "Cash In Goal Detail",
            },
          })}
          handleAutoDeposit={handleRSP}
          isBackgroundGrayed
          testId="goal-detail-cashin-btn"
        />
      </div>
    </Box>
  );
};

const withConnect = connect(
  state => ({
    customerGoals: state.goal.customerGoals,
    transactionHistory: state.goal.transactionHistory,
    ecddStatus: state.goal.ecddStatus,
    profile: state.goal.profile,
    rspDetail: state.autoDepositReducer.rspDetail,
    commingFrom: state.commingFromReducer.commingFrom,
    blockRequest: state.commingFromReducer.blockRequest,
    loadingTransactionHistory: state.goal.loadingTransactionHistory,
    isEcddCompleted: state.commingFromReducer.isEcddCompleted,
    loadingRspDetail: state.autoDepositReducer.loadingRspDetail,
    ...state.goalDetailReducer,
  }),
  {
    getTransactionHistory, // API
    setSavingGoalDetails,
    setGeneralSavingDetails,
    setSavingType,
    getCustomer, // API
    setbackPayloadRsp,
    getRspDetail, // API
    getSubAccount, // API
    setBlockRequest,
    setCifPlanId,
    setCurrentEcddStatus,
    resetSelectedPromo,
    setLastAmountSave,
  }
);

export default compose(
  withRouter,
  withConnect,
  withProfileRedirect
)(GoalDetails);
